<div class="detail-card activity">
  <div class="card-bar">
    <h3>{{"Transactions" | tenantWords}}</h3>
    <span class="count-pill">{{entries.length}}</span>
  </div>

  <div *ngIf="!entries.length" class="activity-empty">No transactions recorded yet.</div>

  <ol class="activity-list">
    <li *ngFor="let entry of entries; trackBy: trackTransaction" class="activity-item" [ngClass]="'tone-' + entry.tone">
      <span class="activity-marker">
        <fa-icon [icon]="entry.icon"></fa-icon>
      </span>

      <div class="activity-body">
        <div class="activity-title-row">
          <span class="activity-title">{{entry.label}}</span>
          <time class="activity-time" [title]="entry.transaction.createdDate | date:'medium'">
            {{entry.transaction.createdDate | date:'MMM d, y · h:mm a'}}
          </time>
        </div>
        <div class="activity-meta">
          {{entry.transaction.createdBy || 'System'}}
          <span *ngIf="entry.transaction.reasonCode" class="activity-tag">{{entry.transaction.reasonCode}}</span>
        </div>

        <p *ngIf="entry.transaction.details" class="activity-details">{{entry.transaction.details}}</p>

        <div *ngIf="entry.qtyChanged" class="activity-change">
          <span class="change-label">Qty</span>
          <span>{{entry.transaction.originalQty | number}}</span>
          <fa-icon [icon]="faArrowRight" class="change-arrow"></fa-icon>
          <span class="change-to">{{entry.transaction.adjustedQty | number}}</span>
        </div>

        <div *ngFor="let move of entry.moves" class="activity-change">
          <span class="change-label">{{move.label}}</span>
          <span>{{move.from}}</span>
          <fa-icon [icon]="faArrowRight" class="change-arrow"></fa-icon>
          <span class="change-to">{{move.to}}</span>
        </div>
      </div>
    </li>
  </ol>
</div>
